import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import {
  NEFI_CURRENT_TEST_SUITE,
  shouldFillNEFITestData,
} from 'components/NEFIForm/NEFITestdata/NEFITestSetup';

const NEFISteps = createContext({});

export const useNEFISteps = () => useContext(NEFISteps);

export const NEFIStepsContext = ({ children }) => {
  const [activeStep, setActiveStep] = useState(0);

  const [submittedValues, setSubmittedValues] = useState(
    shouldFillNEFITestData
      ? { ...NEFI_CURRENT_TEST_SUITE }
      : {
          step0: {},
          step1: {},
          step2: {},
          step3: {},
        }
  );

  const setSubmittedValuesWithStep = (step, values) => {
    setSubmittedValues((oldValues) => ({ ...oldValues, [`step${step}`]: values }));
  };

  const clearSubmittedValuesWithStep = (step) => {
    setSubmittedValues((oldValues) => ({ ...oldValues, [`step${step}`]: {} }));
  };
  // forced by react-hooks/exhaustive-deps
  const getSubmittedValuesWithStep = useCallback(
    (step) => submittedValues[`step${step}`],
    [submittedValues]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  const contextValue = useMemo(
    () => ({
      activeStep,
      setActiveStep,
      getSubmittedValuesWithStep,
      setSubmittedValuesWithStep,
      clearSubmittedValuesWithStep,
    }),
    [activeStep, setActiveStep, getSubmittedValuesWithStep]
  );

  return <NEFISteps.Provider value={contextValue}>{children}</NEFISteps.Provider>;
};
NEFIStepsContext.propTypes = {
  children: PropTypes.node.isRequired,
};
